import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { toggleDsPick } from 'redux/mode/actions';
import { DesignSystemToken } from 'designSystem/types';
import * as Base from '../styles';
import * as S from './styles';

interface OpacityScaleProps {
	tokens: DesignSystemToken[];
}

const getOpacity = (token: DesignSystemToken): number =>
	token.value.kind === 'opacity' ? token.value.value : 0;

const OpacityScale = ({ tokens }: OpacityScaleProps) => {
	const dispatch = useDispatch();
	const selectedPicks = useSelector((r: RootReducer) => r.mode.selectedDsPicks);

	const sorted = useMemo(
		() => [...tokens].sort((a, b) => getOpacity(a) - getOpacity(b)),
		[tokens]
	);

	const isSelected = (token: DesignSystemToken) =>
		selectedPicks.some((p) => p.kind === 'token' && p.cssVariable === token.cssVariable);

	return (
		<Base.ScaleRow>
			{sorted.map((token) => {
				const opacity = getOpacity(token);
				return (
					<Base.ScaleItem
						key={token.id}
						type="button"
						$selected={isSelected(token)}
						onClick={() =>
							dispatch(toggleDsPick({ kind: 'token', cssVariable: token.cssVariable }))
						}
					>
						<Base.ScaleTooltip>{token.cssVariable} — {Math.round(opacity * 100)}%</Base.ScaleTooltip>
						<S.Box>
							<S.Overlay $opacity={opacity} />
						</S.Box>
						<Base.ScaleLabel>{token.name}</Base.ScaleLabel>
						<Base.ScaleValue>{Math.round(opacity * 100)}%</Base.ScaleValue>
					</Base.ScaleItem>
				);
			})}
		</Base.ScaleRow>
	);
};

export default OpacityScale;
